export default __webpack_public_path__ + "static/media/limit.7b30ada0.svg";